// @ is an alias to /src
import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  announcements: [],
  announcementsSystem: [],
  announcementsInternal: [],
  totalAnnouncementsSystem: 0,
  totalAnnouncementsInternal: 0,
  isCreatedAnnouncement: false,
}

export const mutations = {
  SET_ANNOUNCEMENTS(state, announcements) {
    state.announcements = announcements
  },
  SET_ANNOUNCEMENTS_SYSTEM(state, announcements) {
    state.announcementsSystem = announcements
  },
  SET_ANNOUNCEMENTS_INTERNAL(state, announcements) {
    state.announcementsInternal = announcements
  },
  SET_TOTAL_ANNOUNCEMENTS_SYSTEM(state, total) {
    state.totalAnnouncementsSystem = total
  },
  SET_TOTAL_ANNOUNCEMENTS_INTERNAL(state, total) {
    state.totalAnnouncementsInternal = total
  },
  SET_IS_CREATED_ANNOUNCEMENT(state, value) {
    state.isCreatedAnnouncement = value
  },
  ADD_ANNOUNCEMENT(state, announcement) {
    state.announcements.push(announcement)
  },
  EDIT_ANNOUNCEMENT(state, announcement) {
    const index = state.announcements.findIndex(
      (item) => item.announcement_uuid === announcement.announcement_uuid
    )
    if (index !== -1) state.announcements.splice(index, 1, announcement)
  },
  DELETE_ANNOUNCEMENT(state, announcement_uuid) {
    const index = state.announcements.findIndex(
      (item) => item.announcement_uuid === announcement_uuid
    )
    if (index !== -1) state.announcements.splice(index, 1)
  },
}

export const actions = {
  fetchAnnouncements({ commit }, payload) {
    return ApiService.fetchAnnouncements(payload)
      .then((res) => {
        const announcements = res.data.data
        commit('SET_ANNOUNCEMENTS', announcements)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchAnnouncementSystem({ commit }, payload) {
    return ApiService.fetchAnnouncementSystem(payload)
      .then((res) => {
        const announcements = res.data.data
        commit('SET_ANNOUNCEMENTS_SYSTEM', announcements)
        commit('SET_TOTAL_ANNOUNCEMENTS_SYSTEM', res.data.total)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchAnnouncementInternal({ commit }, payload) {
    return ApiService.fetchAnnouncementInternal(payload)
      .then((res) => {
        const announcements = res.data.data
        commit('SET_ANNOUNCEMENTS_INTERNAL', announcements)
        commit('SET_TOTAL_ANNOUNCEMENTS_INTERNAL', res.data.total)
      })
      .catch((error) => {
        throw error
      })
  },
  addAnnouncement({ commit }, payload) {
    return ApiService.addAnnouncement(payload)
      .then((res) => {
        const announcement = res.data
        commit('ADD_ANNOUNCEMENT', announcement)
        return announcement
      })
      .catch((error) => {
        throw error
      })
  },
  editAnnouncement({ commit }, payload) {
    return ApiService.editAnnouncement(payload)
      .then((res) => {
        const announcement = res.data
        commit('EDIT_ANNOUNCEMENT', announcement)
      })
      .catch((error) => {
        throw error
      })
  },
  deleteAnnouncement({ commit }, payload) {
    return ApiService.deleteAnnouncement(payload)
      .then(() => {
        commit('DELETE_ANNOUNCEMENT', payload.announcement_uuid)
      })
      .catch((error) => {
        throw error
      })
  },
  sendAnnouncement(_, payload) {
    return ApiService.sendAnnouncement(payload).catch((error) => {
      throw error
    })
  },
  addSystemAnnouncementIsRead(_, payload) {
    return ApiService.addSystemAnnouncementIsRead(payload).catch((error) => {
      throw error
    })
  },
  addSystemAnnouncementIsNotShowAgain(_, payload) {
    return ApiService.addSystemAnnouncementIsNotShowAgain(payload).catch(
      (error) => {
        throw error
      }
    )
  },
  addAnnouncementIsRead(_, payload) {
    return ApiService.addAnnouncementIsRead(payload).catch((error) => {
      throw error
    })
  },
  addAnnouncementIsNotShowAgain(_, payload) {
    return ApiService.addAnnouncementIsNotShowAgain(payload).catch((error) => {
      throw error
    })
  },
}

export const getters = {}
